import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { GoogleChartsModule } from 'angular-google-charts';
import { AutocompleteMultiselectComponent } from './autocomplete-multiselect/autocomplete-multiselect.component';
import { BaInputComponent } from './ba-input/ba-input.component';
import { RfrButtonComponent } from './rfr-button/rfr-button.component';
import { RfrDatePickerComponent } from './rfr-date-picker/rfr-date-picker.component';
import { RfrDatetimePickerComponent } from './rfr-datetime-picker/rfr-datetime-picker.component';
import { RfrHorizontalMenuComponent } from './rfr-horizontal-menu/rfr-horizontal-menu.component';
import { RfrInputLocationComponent } from './rfr-input-location/rfr-input-location.component';
import { RfrInputPasswordComponent } from './rfr-input-password/rfr-input-password.component';
import { RfrInputPhoneComponent } from './rfr-input-phone/rfr-input-phone.component';
import { RfrInputComponent } from './rfr-input/rfr-input.component';
import { RfrReadonlyComponent } from './rfr-readonly/rfr-readonly.component';
import { RfrSelectComponent } from './rfr-select/rfr-select.component';
import { RfrTimePickerComponent } from './rfr-time-picker/rfr-time-picker.component';
import { RfrTimelineChart2Component } from './rfr-timeline-chart-2/rfr-timeline-chart-2.component';
import { RfrTimelineChartComponent } from './rfr-timeline-chart/rfr-timeline-chart.component';
import { RfrVerticalMenuComponent } from './rfr-vertical-menu/rfr-vertical-menu.component';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
// import { ThemeToggleComponentModule } from "../molecules/theme-toggle/theme-toggle.module";
import { ThemeToggleComponent } from '../molecules/theme-toggle/theme-toggle.component';
import { SettingSubmenuPopoverComponent } from './setting-submenu-popover/setting-submenu-popover.component';
import { CustomDialogComponent } from './custom-dialog/custom-dialog.component';
import { AutocompleteSingleselectComponent } from './autocomplete-singleselect/autocomplete-singleselect.component';
import { TableControlsComponent } from './table-controls/table-controls.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { ArchiveAssignmentBlockedModalComponent } from '../molecules/archive-assignment-blocked-modal/archive-assignment-blocked-modal.component';

@NgModule({
  declarations: [
    RfrHorizontalMenuComponent,
    RfrVerticalMenuComponent,
    //MainPageWrapperComponent,
    RfrButtonComponent,
    RfrInputComponent,
    RfrInputPasswordComponent,
    RfrSelectComponent,
    RfrInputPhoneComponent,
    //KnightPageWrapperComponent,
    RfrDatePickerComponent,
    BaInputComponent,
    RfrDatetimePickerComponent,
    RfrTimelineChartComponent,
    RfrTimelineChart2Component,
    RfrTimePickerComponent,
    RfrReadonlyComponent,
    AutocompleteMultiselectComponent,
    AutocompleteSingleselectComponent,
    RfrInputLocationComponent,
    VideoDialogComponent,
    ThemeToggleComponent,
    SettingSubmenuPopoverComponent,
    CustomDialogComponent,
    TableControlsComponent,
    ConfirmationModalComponent,
    InfoModalComponent,
    ArchiveAssignmentBlockedModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    NgxChartsModule,
    GoogleChartsModule,
    NgxDatatableModule,
    BreadcrumbComponent
  ],
  exports: [
    RfrHorizontalMenuComponent,
    RfrVerticalMenuComponent,
    //MainPageWrapperComponent,
    RfrButtonComponent,
    RfrInputComponent,
    RfrInputPasswordComponent,
    RfrSelectComponent,
    //KnightPageWrapperComponent,
    RfrDatePickerComponent,
    RfrInputPhoneComponent,
    BaInputComponent,
    RfrDatetimePickerComponent,
    RfrTimelineChartComponent,
    RfrTimelineChart2Component,
    RfrTimePickerComponent,
    RfrReadonlyComponent,
    AutocompleteMultiselectComponent,
    AutocompleteSingleselectComponent,
    RfrInputLocationComponent,
    VideoDialogComponent,
    ThemeToggleComponent,
    SettingSubmenuPopoverComponent,
    CustomDialogComponent,
    TableControlsComponent,
    BreadcrumbComponent,
    ConfirmationModalComponent,
    InfoModalComponent,
    ArchiveAssignmentBlockedModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class GlobalComponentsModule {}
